import { enumTrailerStatus } from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { TrailerFormState } from '~/modules/transportation/types';

const initialState: TrailerFormState = {
  status: enumTrailerStatus.Available,
  licensePlate: '',
  capacity: 0,
  country: '',
  state: '',
  transportationTypeId: '',
  facilityId: '',
};

export const $trailerForm = atom<TrailerFormState>(initialState);

export const $resetTrailerForm = atom(null, (get, set) => {
  set($trailerForm, initialState);
});

export const $updateTrailerForm = atom(
  null,
  (get, set, update: Partial<TrailerFormState>) => {
    set($trailerForm, {
      ...get($trailerForm),
      ...update,
    });
  },
);
